module.exports = __webpack_public_path__ + "static/media/instagram.b6c744ed.svg";